import { generateHashedString } from '@/utils/generateHashedString';

/**
 * Wabunka 予約作成Form用 Composable
 * formは、グローバルに変更できる
 */
export const useWabunkaPushGtmDatalayer = () => {
  // GTMのdatalayerにハッシュ化したEmailをpushする
  const pushHashedEmailToGtmDatalayer = async (email: string) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!window || !(window as any).dataLayer) {
      return;
    }
    // Meta の詳細マッチング仕様に合わせ、trim + 小文字化してから SHA-256 でハッシュ化する
    // @see https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/customer-information-parameters
    const normalizedEmail = email.trim().toLowerCase();
    // 空メール（空文字・空白のみ）は push しない。空文字のハッシュは固定値になり、
    // マッチングに使えないパラメーターとして計測品質を下げるため
    if (!normalizedEmail) {
      return;
    }
    const hashedEmail = await generateHashedString(normalizedEmail);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).dataLayer.push({
      hashedEmail: hashedEmail,
    });
  };

  return {
    pushHashedEmailToGtmDatalayer,
  };
};
